export default "__VITE_ASSET__p7R8NlaA__"